<section>
	<ng-container *ngIf="visualAssets && !visualAssetEmpty">
		<shared-media-component-homr-asset
			[visualAssets]="visualAssets"
			[itemTitle]="itemTitle"
			[imageWidthParam]="imageWidthParam"
			[altText]="altText"
			[prioritize]="prioritize"
			[willLazyLoad]="willLazyLoad">
		</shared-media-component-homr-asset>
	</ng-container>
	<ng-container *ngIf="visualAssetEmpty || !visualAssets">
		<shared-media-component-video
			*ngIf="youtubeId || animation"
			[altText]="altText"
			[image]="image"
			[itemTitle]="itemTitle"
			[youtubeId]="youtubeId"
			[animation]="animation">
		</shared-media-component-video>
		<shared-media-component-scene7
			*ngIf="!youtubeId && !animation"
			[gif]="gif"
			[gifMobile]="gifMobile"
			[altText]="altText"
			[image]="image"
			[mobileImg]="mobileImg"
			[itemTitle]="itemTitle"
			[imagePreset]="imagePreset"
			[willLazyLoad]="willLazyLoad">
		</shared-media-component-scene7>
	</ng-container>
</section>
